module.exports = __webpack_public_path__ + "static/media/categories.2a2a2c69.svg";